// extracted by mini-css-extract-plugin
export default {"heroImage":"heroImage-eXlG0"};